import React from 'react'


const Roadmap = () => {

    React.useEffect(() => {
        const elementResal = document.querySelectorAll('.elementResal');
  
        const conObs = {
          root: null,
          rootMargin: '-49% 0px -49% 0px',
          threshold: 0
        };
      
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('activeRoad')
                } else {
                    entry.target.classList.remove('activeRoad')
                }
            });
        }, conObs);
      
      
        elementResal.forEach(item => {
            observer.observe(item);
        });
    })
    

    return (
        <div className='road flex centerflex vertcenter secPad relative'>
            <div className="container-lg flexcol centerflex vertcenter lineMap relative">
                <h2>Roadmap</h2>
                <div className="elementResal cardRoad">
                    <span>1</span>
                    · Creating the discord community (Special benefits for the first 250 members)
                </div>
                <div className="elementResal cardRoad">
                    <span>2</span>
                    · Launch of the official BPG website (27/12/2021)
                </div>
                <div className="elementResal cardRoad">
                    <span>3</span>
                    · Official BPG Diaper collection release (27/12/2021  23:00 UTC) - MINT
                </div>
                <div className="elementResal cardRoad">
                    <span>4</span>
                    · Receipt of returns associated with NFTs by holders (31/01/2022)
                </div>
                <div className="elementResal cardRoad">
                    <span>5</span>
                    · Special event 1 for NFT holders (Winter 2022)
                </div>
                <div className="elementResal cardRoad">
                    <span>6</span>
                    · Special event 2 for NFT holders (Spring 2022)
                </div>
                <div className="elementResal cardRoad">
                    <span>7</span>
                    · Fully customized merchandising for NFT holders (Summer 2022)
                </div>
                <div className="elementResal cardRoad">
                    <span>8</span> 
                    · Large investment by BPG for holders' profits (Summer 2022)
                </div>
            </div>
        </div>
    )
}

export default Roadmap
